export const ADMINISTRATOR_ROLE = "administrator";
export const TECHNICIAN_ROLE = "technician";

export const MAX_SENSORS_GRAPH_DATA = 4;
export const MAX_DATE_RANGE_DAYS = 120;

export const DATA_REPORT_TABLE_VIEW = "table";
export const DATA_REPORT_GRAPH_VIEW = "graph";

export const DEVICE_SENSORS_DIAGRAM_VIEW = "diagram";
export const DEVICE_SENSORS_TABLE_VIEW = "table";

export const REPORT_TYPES = {
  DATA_REPORT: "data_report",
  EVENT_LOG_REPORT: "event_log_report",
  DISINFECTION_REPORT: "heat_disinfection_report",
  EVOLUTION_REPORT: "evolution_report",
  UPLOAD_DOCUMENT: "custom",
} as const;
